import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { map } from 'rxjs/operators';

import { environment } from 'src/environments/environment';
import { SortableTable, convertDateToDisplayFormat, convertDateToBackendFormat } from './services-table-helper';
import { RaportIncasare } from '../models/rapoarte-incasari.model';

@Injectable({
  providedIn: 'root'
})

export class RapoarteIncasariTableService extends SortableTable<RaportIncasare> {
  private baseUrl = environment.API_URL;

  rapoarteIncasari: RaportIncasare[];
  numarRapoarteIncasari: number;

  constructor(private http: HttpClient) {
    super();
  }

  sortEvent() {
    const tables = this.sort(this.rapoarteIncasari, this._state.sortColumn, this._state.sortDirection);
    this._tables$.next(tables);
  }

  getRapoarteIncasariAPI(obj) {
    return this.http.post(
      `${this.baseUrl}/contabilitate/rapoarte/facturineachitate/`,
      obj
    ).pipe(map((response: any) => {
      this.rapoarteIncasari = response.result;
      this.numarRapoarteIncasari = response.count;

      this.rapoarteIncasari.map((raport: RaportIncasare) => {
        raport.data = convertDateToDisplayFormat(raport.data);
      });

      this.paginate();
      this.sortEvent();
      this._total$.next(this.numarRapoarteIncasari);

      return response;
    }));
  }

  exportXLS(obj) {
    return this.http
    .post(
      `${this.baseUrl}/contabilitate/rapoarte/facturineachitatexlsx/`,
      {
        ...obj,
        data: convertDateToBackendFormat(obj.data)
      },
      {
        responseType: 'blob'
      }
    ).pipe(map((response: any) => {
      return response;
    }));
  }

  /**
   * Paginate Method
   */
  private paginate(): void {
    this.totalRecords = this.numarRapoarteIncasari;
    this._state.startIndex = (this._state.page - 1) * this.pageSize + 1;
    this._state.endIndex = Number(this.pageSize) + Number(this._state.startIndex - 1);

    if (this._state.endIndex > this.numarRapoarteIncasari) {
      this._state.endIndex = this.numarRapoarteIncasari;
    }
  }
}
